import React from 'react';
import RichText from '../rich-text';

interface Props {
	title?: string;
	description?: string;
	width?: string;
	titleClassName?: string;
	descriptionClassName?: string;
	children: React.JSX.Element | React.JSX.Element[];
}

export default function Section({ title, description, width, titleClassName, descriptionClassName, children }: Props) {
	return (
		<section data-testid="section" className={'flex flex-col items-center gap-8 lg:gap-12 mx-auto w-full' + (width?` ${width}` : '')}>
			{ (title || description) &&
				<div className="flex flex-col gap-5 w-full">
					{title && <h2 className={titleClassName ?? 'text-2xl text-center'}><RichText html={title} /></h2>}
					{description && <p className={descriptionClassName ?? 'text-lg text-center'}><RichText html={description} /></p>}
				</div>
			}
			{children}
		</section>
	);
}
